module.exports = {
	name : "Boids",
	description : "A flocking algorithm",
	order : 0,
	config : {
		camera : {
			x : -300,
			near : 0.1,
			far : 5000,
			fov : 40
		}
	},
	components : {
		renderer : { function : require('../js/renderers/basic-renderer') },
		// renderer : {
		// 	function : require('../js/renderers/effects-renderer'),
		// 	properties : {
		// 		clearColor : 0x121212
		// 	}
		// },
		
		controls : { construct: require("../js/components/cameras/Controls") },
		mouse : { function: require('../js/components/hids/mouse-tracker')	},
		fboPositioning : { function: require('../js/demos/boids/boids') },
		
		sky: {
			function: require('../js/components/ambiance/Sky'),
			properties : {
				width : 30
			}
		}
	}
};